import { TLocoType } from 'shared/hooks/use-loco-translation'

export const getCourseThemesData = (t: TLocoType) => [
  { id: null, caption: t('dashboard.course.theme_default_title') },
  { id: 2, caption: t('dashboard.course.theme_beige_title') },
  { id: 3, caption: t('dashboard.course.theme_green_title') },
  { id: 4, caption: t('dashboard.course.theme_purple_title') },
  { id: 5, caption: t('dashboard.course.theme_teal_title') },
  { id: 6, caption: t('dashboard.course.theme_black_title') },
  { id: 7, caption: t('dashboard.course.theme_orange_title') },
  { id: 8, caption: t('dashboard.course.theme_red_title') },
  { id: 9, caption: t('dashboard.course.theme_pink_title') },
  { id: 10, caption: t('dashboard.course.theme_yellow_title') },
  { id: 11, caption: t('dashboard.course.theme_intense_purple_title') },
  { id: 12, caption: t('dashboard.course.theme_light_red_title') },
  { id: 13, caption: t('dashboard.course.theme_light_blue_title') },
]
